import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Render chat text as Markdown (default) or plain pre-wrapped text.
 */
export default function ChatMessageContent({ content, markdown = true, className = '' }) {
  const text = typeof content === 'string' ? content : '';
  if (!text) return null;

  if (!markdown) {
    return (
      <div className={className || undefined} style={{ whiteSpace: 'pre-wrap' }}>
        {text}
      </div>
    );
  }

  return (
    <div className={`chat-markdown${className ? ` ${className}` : ''}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
    </div>
  );
}
